export const env = "https://wordket.xyz:4200/"
//export const env = "http://localhost:4200/"